var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.defaultHeaders,"no-data-text":_vm.loadingOrNoDataText,"group-desc":false,"items":_vm.totals,"hide-default-footer":""}})}
var staticRenderFns = []

export { render, staticRenderFns }